import { render, staticRenderFns, recyclableRender, components } from "./sexSelect.vue?vue&type=template&id=3f867fce&scoped=true&"
var renderjs
import script from "./sexSelect.vue?vue&type=script&lang=js&"
export * from "./sexSelect.vue?vue&type=script&lang=js&"
import style0 from "./sexSelect.vue?vue&type=style&index=0&id=3f867fce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f867fce",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/common/sexSelect.vue"
export default component.exports